import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

type Props = {
  url?: string;
};

type UseRouteStateReturn = {
  isLoading: boolean;
};

const useRouteState = ({ url }: Props = {}): UseRouteStateReturn => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const startEventHandler = (currentUrl: string) => {
      if (currentUrl === router.asPath || !url || (currentUrl.includes(url) && router.asPath.includes(url))) {
        setIsLoading(true);
      }
    };

    const endEventHandler = (currentUrl: string) => {
      if (currentUrl === router.asPath || !url || currentUrl.includes(url)) {
        setIsLoading(false);
      }
    };

    const errorEventHandler = () => {
      setIsLoading(false);
    };

    router.events.on('routeChangeStart', startEventHandler);
    router.events.on('routeChangeComplete', endEventHandler);
    router.events.on('routeChangeError', errorEventHandler);

    return () => {
      router.events.off('routeChangeStart', startEventHandler);
      router.events.off('routeChangeComplete', endEventHandler);
      router.events.off('routeChangeError', errorEventHandler);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { isLoading };
};

export default useRouteState;
